export const MapLayer = {
  VesselSymbolLayer: {
    id: "VesselSymbolLayer"
  },
  VesselSymbolFarLayer: {
    id: "VesselSymbolFarLayer"
  },
  VesselTextLayer: {
    id: "VesselTextLayer"
  },
  VesselCircleLayer: {
    id: "VesselCircleLayer"
  },
  VesselVectorLayer: {
    id: "VesselVectorLayer"
  },
  VesselPolygonLayer: {
    id: "VesselPolygonLayer"
  },
  VesselSizeWithoutLayer: {
    id: "VesselSizeWithoutLayer"
  },
  VesselWakeLineLayer: {
    id: "VesselWakeLineLayer"
  },
  VesselWakeLineLayerForClickEvent: {
    id: "VesselWakeLineLayerForClickEvent"
  },
  VesselTargetLayer: {
    id: "VesselTargetLayer"
  },
  OwnVesselMarkerLayer: {
    id: "OwnVesselMarkerLayer"
  },
  OwnVesselSymbolLayer: {
    id: "OwnVesselSymbolLayer"
  },
  OwnVesselPolygonLayer: {
    id: "OwnVesselPolygonLayer"
  },
  OwnVesselVectorLayer: {
    id: "OwnVesselVectorLayer"
  },
  OwnVesselTextLayer: {
    id: "OwnVesselTextLayer"
  },
  OwnVesselSizeWithoutLayer: {
    id: "OwnVesselSizeWithoutLayer"
  },
  SelectedVesselSymbolLayer: {
    id: "SelectedVesselSymbolLayer"
  },
  SelectedVesselPolygonLayer: {
    id: "SelectedVesselPolygonLayer"
  },
  SelectedVesselVectorLayer: {
    id: "SelectedVesselVectorLayer"
  },
  SelectedVesselTextLayer: {
    id: "SelectedVesselTextLayer"
  },
  SelectedVesselMarkerLayer: {
    id: "SelectedVesselMarkerLayer"
  },
  SelectedVesselSizeWithoutLayer: {
    id: "SelectedVesselSizeWithoutLayer"
  }
};

export const MapSource = {
  VesselPointSource: {
    id: "VesselPointSource"
  },
  VesselVectorSource: {
    id: "VesselVectorSource"
  },
  VesselPolygonSource: {
    id: "VesselPolygonSource"
  },
  VesselWakeLineSource: {
    id: "VesselWakeLineSource"
  },
  VesselWakeLineSourceForClickEvent: {
    id: "VesselWakeLineSourceForClickEvent"
  },
  VesselTargetSource: {
    id: "VesselTargetSource"
  },
  OwnVesselMarkerSource: {
    id: "OwnVesselMarkerSource"
  },
  OwnVesselPointSource: {
    id: "OwnVesselPointSource"
  },
  OwnVesselPolygonSource: {
    id: "OwnVesselPolygonSource"
  },
  OwnVesselVectorSource: {
    id: "OwnVesselVectorSource"
  },
  SelectedVesselPointSource: {
    id: "SelectedVesselPointSource"
  },
  SelectedVesselPolygonSource: {
    id: "SelectedVesselPolygonSource"
  },
  SelectedVesselVectorSource: {
    id: "SelectedVesselVectorSource"
  },
  SelectedVesselMarkerSource: {
    id: "SelectedVesselMarkerSource"
  }
};

export const LiveVesselMapLayer = {
  LiveVesselTextLayer: {
    id: "LiveVesselTextLayer"
  },
  LiveVesselSymbolLayer: {
    id: "LiveVesselSymbolLayer"
  },
  LiveVesselSymbolWithoutSizeLayer: {
    id: "LiveVesselSymbolWithoutSizeLayer"
  },
  LiveVesselWakeLineLayer: {
    id: "LiveVesselWakeLineLayer"
  },
  LiveVesselWakeLineLayerForClickEvent: {
    id: "LiveVesselWakeLineLayerForClickEvent"
  },
  LiveVesselPolygonLayer: {
    id: "LiveVesselPolygonLayer"
  },
  LiveVesselWithoutSizeLayer: {
    id: "LiveVesselWithoutSizeLayer"
  },
  LiveVesselVectorLayer: {
    id: "LiveVesselVectorLayer"
  },
  LiveVesselPulsingLayer: {
    id: "LiveVesselPulsingLayer"
  }
};

export const LiveVesselMapSource = {
  LiveVesselTextSource: {
    id: "LiveVesselTextSource"
  },
  LiveVesselSymbolSource: {
    id: "LiveVesselSymbolSource"
  },
  LiveVesselWakeLineSource: {
    id: "LiveVesselWakeLineSource"
  },
  LiveVesselWakeLineSourceForClickEvent: {
    id: "LiveVesselWakeLineSourceForClickEvent"
  },
  LiveVesselPolygonSource: {
    id: "LiveVesselPolygonSource"
  },
  LiveVesselWithoutSizeSource: {
    id: "LiveVesselWithoutSizeSource"
  },
  LiveVesselVectorSource: {
    id: "LiveVesselVectorSource"
  },
  LiveVesselPulsingSource: {
    id: "LiveVesselPulsingSource"
  }
};

export const VoyageHistoryMapLayer = {
  VoyageHistoryVesselTextLayer: {
    id: "VoyageHistoryVesselTextLayer"
  },
  VoyageHistoryVesselSymbolLayer: {
    id: "VoyageHistoryVesselSymbolLayer"
  },
  VoyageHistoryVesselWakeLineLayer: {
    id: "VoyageHistoryVesselWakeLineLayer"
  },
  VoyageHistoryVesselPolygonLayer: {
    id: "VoyageHistoryVesselPolygonLayer"
  },
  VoyageHistoryVesselWithoutSizeLayer: {
    id: "VoyageHistoryVesselWithoutSizeLayer"
  }
};

export const VoyageHistoryMapSource = {
  VoyageHistoryVesselMapSource: {
    id: "VoyageHistoryVesselMapSource"
  },
  VoyageHistoryVesselTextSource: {
    id: "VoyageHistoryVesselTextSource"
  },
  VoyageHistoryVesselSymbolSource: {
    id: "VoyageHistoryVesselSymbolSource"
  },
  VoyageHistoryVesselWakeLineSource: {
    id: "VoyageHistoryVesselWakeLineSource"
  },
  VoyageHistoryVesselPolygonSource: {
    id: "VoyageHistoryVesselPolygonSource"
  },
  VoyageHistoryVesselWithoutSizeSource: {
    id: "VoyageHistoryVesselWithoutSizeSource"
  }
};

export const PlotMapLayer = {
  PlotTextLayer: {
    id: "PlotTextLayer"
  },
  PlotPolygonTextLayer: {
    id: "PlotPolygonTextLayer"
  },
  PlotSymbolLayer: {
    id: "PlotSymbolLayer"
  },
  PlotPolygonLayer: {
    id: "PlotPolygonLayer"
  }
};

export const PlotMapSource = {
  PlotPointSource: {
    id: "PlotPointSource"
  },
  PlotPolygonSource: {
    id: "PlotPolygonSource"
  }
};

export const PlotEditMapLayer = {
  PlotEditPolygonLayer: {
    id: "PlotEditPolygonLayer"
  },
  PlotEditLineLayer: {
    id: "PlotEditLineLayer"
  },
  PlotEditCircleLayer: {
    id: "PlotEditCircleLayer"
  },
  PlotEditSymbolLayer: {
    id: "PlotEditSymbolLayer"
  }
};

export const PlotEditMapSource = {
  PlotEditPointSource: {
    id: "PlotEditPointSource"
  },
  PlotEditPolygonSource: {
    id: "PlotEditPolygonSource"
  }
};


export const PolarisMapSource = {
  PolarisOffingWavePointSource: {
    id: "PolarisOffingWavePointSource"
  },
};

export const FloatingUnitMapLayer = {
  FloatingUnitTextLayer: {
    id: "FloatingUnitTextLayer"
  },
  FloatingUnitSymbolLayer: {
    id: "FloatingUnitSymbolLayer"
  }
};

export const FloatingUnitMapSource = {
  FloatingUnitPointSource: {
    id: "FloatingUnitPointSource"
  }
};
